module.exports = __webpack_public_path__ + "img/arm-header-icons-05.aee4d295.svg";